import Icon from '@/components/snippets/icon/icon'

export function FilterCollapse({ label, children }) {
  const id = `filter-${label.toLowerCase().replace(/\s/g, '-')}`
  return (
    <x-modal data-id={`filter-${id}`} className="dropdown-modal flex flex-col border-b group/filter border-neutral-medium">
      <button
        className="flex items-center justify-between gap-x-0.75 lg-max:px-margin py-1 link-fade"
        data-modal-parent={`filter-${id}`}
        data-modal-role="toggle"
        aria-label={label}
      >
        <span className="paragraph-m font-medium capitalize">{label}</span>
        <div className={'flex w-[18px] h-[18px] group-data-visible/filter:-rotate-180 transition-all children:size-full'}>
          <Icon id="plus" className='group-data-visible/filter:hidden' />
          <Icon id="minus" className='hidden group-data-visible/filter:block' />
        </div>
      </button>
      <div className="dropdown-content">
        <div className="flex flex-col gap-1.5 overflow-hidden opacity-0 group-data-visible/filter:opacity-100 transition-all">
          {children}
        </div>
      </div>
    </x-modal>
  )
}
